import Icon from '../components/Icon.vue'

Icon.register({"glass-martini":{"width":512,"height":512,"paths":[{"d":"M507.3 27.3C517.3 17.3 510.2 0 496 0H16C1.8 0-5.4 17.2 4.7 27.3L216 238.6V472H124C108.5 472 96 484.5 96 500 96 506.6 101.4 512 108 512H404C410.6 512 416 506.6 416 500 416 484.5 403.5 472 388 472H296V238.6L507.3 27.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/glass-martini.js
// module id = EA32
// module chunks = 0